export default __webpack_public_path__ + "static/media/wakeboard_lg.fac62de9.jpg";